<button (click)="buttonPressed()">{{title}}</button>
